import { CustomButton } from "@/components/ui/Buttons";
import { X } from "lucide-react";
import { Dispatch, SetStateAction, useState } from "react";

const tabs = [
  {
    id: "subReddit",
    title: "Sub Reddit",
  },
  {
    id: "keyword",
    title: "Keyword",
  },
];

const SubRedditModal = ({
  setOpen,
}: {
  setOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  const [activeTab, setActiveTab] = useState("subReddit");
  const [inputValue, setInputValue] = useState("");

  const [tags, setTags] = useState<string[]>([]);

  console.log(tags);
  return (
    <section>
      <div className="mb-12">
        {/* header */}
        <div className="flex justify-between items-center mb-1">
          <h5 className="text-sm font-medium leading-none tracking-normal">
            Add a Subreddit or Keyword
          </h5>
          <button
            onClick={() => setOpen(false)}
            className="border border-[#DADADA] size-7 flex justify-center items-center rounded-lg"
          >
            <X color="#53585F" className="h-5" />
          </button>
        </div>
        <p className="text-[#A7A7A7] text-xs leading-none tracking-normal ">
          We’ll watch public Reddit posts & comments for these and surface
          trends, objections, and ideas
        </p>
      </div>

      {/* tabs */}
      <div>
        <div className="flex gap-x-3 items-center">
          <h5 className="text-base leda">Add a</h5>
          <div className="bg-[#EFEFEF] rounded-xl p-1">
            {tabs.map((tab) => (
              <button
                onClick={() => setActiveTab(tab.id)}
                key={tab.id}
                className={`text-base leading-none tracking-normal px-[17px] py-[7px]
            ${
              tab.id === activeTab
                ? "border border-[#E0E0E0] bg-[#E0E0E0] rounded-lg"
                : "text-[#5a7e9e]"
            }
            
            `}
              >
                {tab.title}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Add cta */}
      <div className="mt-3">
        <div className="flex gap-x-1 w-full items-stretch">
          <input
            onChange={(e) => setInputValue(e.currentTarget.value)}
            type="text"
            placeholder="e.g., r/SkincareAddiction"
            className="border border-[#E4E4E4] rounded-lg px-3 py-1 placeholder:text-[#A9A9A9] text-[#000000] text-sm leading-none tracking-normal outline-1 flex-1"
            value={inputValue}
          />
          <CustomButton
            onClick={() => {
              if (inputValue.trim() !== "") {
                setTags([...tags, inputValue.trim()]);
                setInputValue("");
              }
            }}
            backgroundColor="#2B2B2B"
            border="1px solid #E0E0E0"
            borderRadius="8px"
            fontSize="16px"
            color="white"
            padding="12px"
            fontWeight="400"
            className="leading-none tracking-normal h-full"
          >
            Add
          </CustomButton>
        </div>

        {/* tags */}
        <div className="flex items-center flex-wrap gap-[13px] mt-3">
          {tags?.map((tag, i) => (
            <div
              key={i}
              className="flex items-center gap-x-[7px] border border-[#E4E7EC] px-[11px] py-1 rounded-lg"
            >
              <p>{tag}</p>
              <button
                onClick={() => setTags(tags.filter((__, idx) => idx !== i))}
              >
                <X color="#53585F" className="h-5" strokeWidth={2.5} />
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SubRedditModal;
